import { AxiosGETRequest, AxiosMutationRequest, RequestMethod } from '@myme/utils';

export const createMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/myme'
};

export const addMymePreviewImageAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/myme/:mymeId/preview-image'
};

export const deleteMymeModuleAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/myme/:mymeId/modules/:moduleId'
};

export const editMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/myme/:mymeId'
};

export const editMymeModulesAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/myme/:mymeId/modules'
};

export const getSingleMymeAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getSingleMymeAPI'],
  path: '/myme/:mymeId'
};

export const getTenantMymeCategoriesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getTenantMymeCategoriesAPI'],
  path: '/myme/categories'
};
